import './i18n/i18n';

import ReactDOM from 'react-dom/client'; 
import App from './App';
import { Provider } from 'react-redux';
import './assets/icon/css/all.css';
import store, { persistor } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
       <BrowserRouter>
      <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);